import React, { createContext, useState } from 'react';

// Create a new context
export const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const [sideMessages, setSideMessages] = useState([]); 
  const [messages, setMessages] = useState([]); 
  console.log("🚀 ~ AppProvider ~ messages:", messages)
  const [responseMessages, setResponseMessages] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [termsState, setTermsState] = useState(false)
  const [privacyState, setPrivacyState] = useState(false)
  
  return (
    <AppContext.Provider value={{ 
        sideMessages, 
        setSideMessages,
        messages,
        setMessages,
        responseMessages,
        setResponseMessages,
        showSuggestions,
        setShowSuggestions,
        termsState,
        setTermsState,
        privacyState,
        setPrivacyState
        }}>
      {children}
    </AppContext.Provider>
  );
};
